import { render, staticRenderFns } from "./DatosParcelas.vue?vue&type=template&id=9bda4eaa"
import script from "./DatosParcelas.vue?vue&type=script&lang=js"
export * from "./DatosParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports